import React, {useContext} from 'react';
import _ from 'lodash';
import {Icon, Label} from 'semantic-ui-react';
import {StatusIndicator} from 'app-ui-componentlibrary';
import {showDollarAmountWithDollar, getPropValues} from 'common/utils';
import ReactHtmlParser from 'react-html-parser';
import {Checkbox} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import {MoreDetailsLink} from '../items/shared/MoreDetailsLink';
import {MODES} from 'common/requestDetails/constants';
import {Contexts, Alert} from 'componentLibrary';
const { RequestDetailsContext} = Contexts;

const ActiveAccordion = ({
  tier,
  isNarrative,
  isValid,
  validationErrors,
  headerTitle,
  total,
  actualTotal,
  actualAllowedTotal,
  handleToggle,
  deleteItem,
  activityKey,
  activityName,
  itemLabel,
  sourcePath,
  instructionText,
  children,
  customText,
  gridLayout,
  editable,
  deletable,
  handleIneligibleItemChangeAndBlur,
  handleNotFullyInScopeItemChangeAndBlur,
  disableFields,
  id,
  toggleEditMode,
  handleItemChangeAndEditMode,
  editLabel,
  headerOptions,
  moreDetailsURL,
  name,
  ineligible,
  ineligibleCheckName,
  ineligiblePath,
  notFullyInScope,
  notFullyInScopeCheckName,
  notFullyInScopePath,
  deferred,
  deferredCheckName,
  deferredPath,
  editMode,
  newlyCreated,
  mode,
}) => {
  const rdContext = useContext(RequestDetailsContext);
  let activeAccordionErrors = [];
  if (validationErrors) {
    try {
      activeAccordionErrors = getPropValues(_.get(validationErrors, 'error'), 'activeAccordionError');
      activeAccordionErrors =  [...new Set(activeAccordionErrors)];
    } catch(err) {
      console.log(`Active accordian passed unserializable errors ${err}`);
    }
  }
  let closeoutReviewMode = mode === MODES.CLOSEOUT_REPORT_REVIEW;
  let showActualTotal = false;
  let actualTotalLabel = _.get(rdContext, 'customizations.actualTotalLabel', 'Actual total');
  let actualAllowedTotalLabel = _.get(rdContext, 'customizations.actualAllowedTotalLabel', 'Actual allowed total');
  if (_.isNumber(actualTotal)) {
    showActualTotal = true && !closeoutReviewMode;
  }
  let showActualAllowedTotal = false;
  if (_.isNumber(actualAllowedTotal)) {
    showActualAllowedTotal = true;
  }

  let toDisplayTotalLabel = showActualTotal ? 'Total: ' : '';
  if (mode === MODES.PAYMENT_REQUEST) toDisplayTotalLabel = 'Total requested: ';

  return (
    <div
      id={`item-${_.join(_.split(sourcePath, '.'), '-')}`}
      className={`app_accordion_budget-tier${tier + 1} w-clearfix`}
      aria-label={activityName}
    >
      {!gridLayout ? (
        <div className="accordion-top-content w-clearfix">
          <a
            href="#"
            onClick={() => handleToggle()}
            className="accordion-caret w-inline-flex"
          >
            <div className="fa-caret-accordion" title={`Close ${headerTitle}`}>
              <Icon name="caret down" />
            </div>
          </a>
          <div className="accordion-clickable-area">
            <a
              href="#"
              onClick={() => handleToggle()}
              className="accordion-clickable-header open w-inline-flex w-clearfix"
            >
              <div className="accordion-alert">
                <div className="fa-alert-accordion">
                  {!isValid && editable && (
                    <StatusIndicator
                      status={'needsAttention'}
                      name={activityName}
                      float="left"
                    />
                  )}
                </div>
              </div>
              <h4
                className={`apph4-accordiion-label on-open ${
                  ineligible ? 'strike-through' : ''
                }`}
              >
                {_.upperFirst(headerTitle)}
              </h4>
              {editLabel || !isNarrative ? (
                <h4 className="apph4-accordiion-label float-right on-open">
                  {editLabel && (
                    <Label className="ui horizontal label">{editLabel}</Label>
                  )}
                  {!isNarrative && (
                    <span
                      title={mode === MODES.PAYMENT_REQUEST ? 'Total requested' : 'Total'}
                    >
                      {toDisplayTotalLabel}
                      {showDollarAmountWithDollar(total)}
                    </span>
                  )}
                  {!isNarrative && showActualTotal && <span> | </span>}
                  {!isNarrative && showActualTotal && (
                    <span title={actualTotalLabel} className="blue">
                      {actualTotalLabel}: {showDollarAmountWithDollar(actualTotal)}
                    </span>
                  )}
                  {!isNarrative && showActualAllowedTotal && <span> | </span>}
                  {!isNarrative && showActualAllowedTotal && (
                    <span title={actualAllowedTotalLabel} className="blue">
                      {actualAllowedTotalLabel}:{' '}
                      {showDollarAmountWithDollar(actualAllowedTotal)}
                    </span>
                  )}
                </h4>
              ) : null}
              {!isNarrative && customText && (
                <div className="text-block_max-cost">{customText}</div>
              )}
            </a>
          </div>
        </div>
      ) : (
        <div className="accordion-top-content w-clearfix">
          <a
            href="#"
            onClick={() => handleToggle()}
            className="accordion-caret w-inline-flex"
            title={`Close ${headerTitle}`}
          >
            <div className="fa-caret-accordion">
              <Icon name="caret down" />
            </div>
          </a>
          <div className="accordion-clickable-area">
            <a
              href="#"
              onClick={() => handleToggle()}
              className="accordion-clickable-header open w-inline-flex w-clearfix"
            >
              <div className="accordion-alert">
                <div className="fa-alert-accordion">
                  {!isValid && editable && (
                    <StatusIndicator
                      status={'needsAttention'}
                      name={activityName}
                      float="left"
                    />
                  )}
                </div>
              </div>

              <h4
                className={`apph4-accordiion-label on-open ${
                  ineligible ? 'strike-through' : ''
                }`}
              >
                {_.upperFirst(headerTitle)}
              </h4>
              <div class="rt-seg_-perc-dollar-amt w-clearfix">
                <h4 class="apph4-accordiion-label float-right tier-3-h">
                  {total.nonFedSharePercent}%
                </h4>
              </div>
              <div class="rt-seg_-perc-dollar-amt w-clearfix">
                <h4 class="apph4-accordiion-label float-right tier-3-h">
                  {editLabel && (
                    <Label className="ui horizontal label">{editLabel}</Label>
                  )}
                  {showDollarAmountWithDollar(total.amount)}
                </h4>
              </div>
              {!isNarrative && customText && (
                <div className="text-block_max-cost">{customText}</div>
              )}
            </a>
          </div>
        </div>
      )}
      {!isNarrative && (
        <>
          <br />
          <div className="open-accordion-actions-section margin-bottom-20">
            <ul className="open-accordion-actions-ul w-clearfix w-list-unstyled reviewmode-ul">
              {headerOptions &&
                editable &&
                !newlyCreated &&
                !ineligible &&
                !closeoutReviewMode && (
                  <li className="open-accordion-actions-li reviewmode-li">
                    {!editMode ? (
                      <a href="#" onClick={toggleEditMode} tabIndex="0">
                        <Icon name="pencil" />
                        Edit this {itemLabel}
                      </a>
                    ) : (
                      <a href="#" onClick={toggleEditMode} tabIndex="0">
                        <Icon name="checkmark" />
                        Close edits
                      </a>
                    )}
                  </li>
                )}
              {!isNarrative && editable && deletable && (
                <li className="open-accordion-actions-li reviewmode-li">
                  <a
                    id={`delete-item-${activityKey}`}
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      deleteItem();
                    }}
                    className="fa--link delete-red"
                    title={`Open pop-up form to confirm deleting item ${activityName}`}
                  >
                    <span className="fa-text-link">
                      <Icon link name="close" color="red" />
                      Delete this {itemLabel}
                    </span>
                  </a>
                </li>
              )}
              {headerOptions && editable && (
                <li className="open-accordion-actions-li reviewmode-li">
                  {!_.includes(disableFields, 'ineligible') ? (
                    <Checkbox
                      title={'Mark item as ineligible'}
                      checked={ineligible}
                      name={ineligibleCheckName}
                      id={`ineligibleCheckName-${id}`}
                      label="Ineligible"
                      disabled={deferred}
                      handleChange={(labelName, value) => {
                        handleIneligibleItemChangeAndBlur(ineligiblePath, value);
                      }}
                    />
                  ) : (
                    <p> {ineligible && <strong> Ineligible </strong>}</p>
                  )}
                </li>
              )}
              {headerOptions && editable && (
                <li className="open-accordion-actions-li reviewmode-li">
                  {!_.includes(disableFields, 'deferred') ? (
                    <Checkbox
                      title={'Mark item as Deferred'}
                      checked={deferred}
                      name={deferredCheckName}
                      id={`deferredCheckName-${id}`}
                      label="Deferred"
                      disabled={ineligible}
                      handleChange={(labelName, value) => {
                        handleItemChangeAndEditMode(deferredPath, value);
                      }}
                    />
                  ) : (
                    <p> {deferred && <strong> Deferred </strong>}</p>
                  )}
                </li>
              )}
              {headerOptions && closeoutReviewMode && (
                <li className="open-accordion-actions-li reviewmode-li">
                  {!_.includes(disableFields, 'notFullyInScope') ? (
                    <Checkbox
                      title={'Mark item as Not fully within the scope of work'}
                      checked={notFullyInScope}
                      name={notFullyInScopeCheckName}
                      id={`notFullyInScopeCheckName-${id}`}
                      label="Not fully within the scope of work"
                      disabled={!editable}
                      handleChange={(labelName, value) => {
                        handleNotFullyInScopeItemChangeAndBlur(
                          notFullyInScopePath,
                          value
                        );
                      }}
                    />
                  ) : (
                    <p>
                      {' '}
                      {notFullyInScope && (
                        <strong> Not fully within the scope of work </strong>
                      )}
                    </p>
                  )}
                </li>
              )}
              {headerOptions && moreDetailsURL && !newlyCreated && !closeoutReviewMode && (
                <li className="open-accordion-actions-li reviewmode-li">
                  <MoreDetailsLink to={moreDetailsURL} itemTitle={name} id={id} />
                </li>
              )}
            </ul>
          </div>
        </>
      )}
      <div className="open-accordion-body w-clearfix">
        {!isNarrative && activeAccordionErrors && 0 < _.size(activeAccordionErrors) && (
          _.map(activeAccordionErrors, (error) => 
            <Alert
              header={error}
              content=""
              type="error"
              dismissable={false}
            />
          )
        )}
        {instructionText && (
          <p className="app-paragraph margin-bottom-40">
            {ReactHtmlParser(instructionText)}
          </p>
        )}
        {children}
      </div>
    </div>
  );
};

export default ActiveAccordion;
